import { NgTemplateOutlet } from '@angular/common';
import {
  afterNextRender,
  Component,
  contentChildren,
  Directive,
  inject,
  input,
  TemplateRef,
  viewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';

@Directive({
  selector: '[admFormAccordionPanel]',
})
export class FormAccordionPanelDirective {
  template = inject(TemplateRef);
  title = input.required<string>();
  formGroup = input<FormGroup>();
}

@Component({
  selector: 'adm-form-accordion',
  imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, NgTemplateOutlet, MatButton],
  templateUrl: './adm-form-accordion.component.html',
  styleUrl: './adm-form-accordion.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AdmFormAccordionComponent {
  panels = contentChildren(FormAccordionPanelDirective);
  expansionPanels = viewChildren(MatExpansionPanel);

  constructor() {
    afterNextRender(() => {
      this.expansionPanels()[0]?.open();
    });
  }

  next(currentPanel: FormAccordionPanelDirective) {
    const currentIndex = this.panels().indexOf(currentPanel);

    //if there is still more panels to go
    if (currentIndex < this.panels().length - 1) {
      const nextPanel = this.panels()[currentIndex + 1];
      nextPanel.formGroup()?.markAllAsTouched();
      this.expansionPanels()[currentIndex].close();
      this.expansionPanels()[currentIndex + 1].open();
      return;
    }
  }
}
